{
  "name": "certlogic-js",
  "version": "1.2.2",
  "description": "Implementation of CertLogic in TypeScript",
  "keywords": [
    "json",
    "logic",
    "jsonlogic",
    "rules",
    "validation",
    "validator"
  ],
  "homepage": "https://github.com/ehn-dcc-development/eu-dcc-business-rules/tree/main/certlogic",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/ehn-dcc-development/eu-dcc-business-rules.git"
  },
  "bugs": {
    "url": "https://github.com/ehn-dcc-development/eu-dcc-business-rules/issues"
  },
  "main": "dist/index.js",
  "typings": "dist/index.d.ts",
  "scripts": {
    "build": "tsc",
    "watch-build": "tsc --watch --incremental",
    "pretest": "npm run build",
    "test": "mocha --recursive dist/test",
    "watch-test": "mocha --watch --recursive dist/test",
    "clean": "rm -rf dist/ && rm -rf node_modules/",
    "check-deps": "dpdm dist/ --circular --exit-code circular:1",
    "precheck-deps": "npm run build"
  },
  "bin": {
    "certlogic-run": "dist/cli.js",
    "certlogic-validate": "dist/validation/cli.js",
    "certlogic-desugar": "dist/misc/desugar-cli.js"
  },
  "author": "Meinte Boersma <meinte.boersma@gmail.com>",
  "contributors": [
    "Steffen Schulze",
    "Denzil Ferreira <denzil.ferreira@solita.fi>"
  ],
  "license": "Apache-2.0",
  "devDependencies": {
    "@types/chai": "^4.3.0",
    "@types/mocha": "^9.1.0",
    "@types/node": "^17.0.17",
    "@types/semver": "^7.3.9",
    "chai": "^4.3.6",
    "dpdm": "^3.8.0",
    "mocha": "^9.2.0",
    "semver": "^7.3.5",
    "typescript": "^4.5.5"
  }
}
